import { UPDATE_BOTS } from '../../mutation-types';

const mutations = {
  [UPDATE_BOTS](state, bots) {
    state.bots = bots;
  },
};

export default mutations;
